import { nameValidator, emailValidator, passwordValidator } from "../../utils/Helpers";

export function G_onInputChangeHandler(event: any) {
    let input: any = {
        error: '',
        name: event.target.name,
        value: event.target.value
    }

    let ifCheckbox: any = (event.target.type === 'checkbox') ? true : false;

    if (ifCheckbox) {
        let checked = event.target.checked;
        let toggleStatus = checked ? 'Y' : 'N'

        input.value = toggleStatus
    } else {
        input.value = event.target.value
    }

    return input
}

export function G_onInputBlurHandler(event: any, title: any, minChar = 3, maxChar = 30) {
    let input: any = {
        error: '',
        name: event.target.name,
        value: event.target.value.trim()
    }

    let tName = event.target.name
    let isrequired = event.target.required

    let tValue = event.target.value.trim()
    // tValue = tValue.replace(/\b\w/g, (char: any) => char.toUpperCase());

    let targetTitle = tName.charAt(0).toUpperCase() + tName.slice(1)
    targetTitle = targetTitle.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c: any) => c.toUpperCase())

    let head = title || targetTitle;
    head = head.toLowerCase();

    if (tValue.length < 1 && event.target.required) {
        /* 
         * Mandatory inputs should not be empty
        */
        switch (tName) {
            case 'amount':
                input.error = 'Kindly add an amount'
                break;

            default:
                input.error = head + ' is required'
                break
        }

        // Capitalize only the first letter of the entire string
        let cleanError = input.error.replace(/_/g, ' ');
        input.error = cleanError.charAt(0).toUpperCase() + cleanError.slice(1);

        return input
    }

    switch (tName) {
        case 'name':
            if (tValue.length < minChar) {
                input.error = 'Please enter a valid ' + head.toLowerCase()
            } else if (tValue.length > maxChar) {
                input.error = head + ' cannot be more than ' + maxChar + ' characters'
            } else {
                const characterCheck = hasInvalidSpecialChars(tValue)

                if (characterCheck.length > 0) {
                    input.error = `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}`;
                } else if (/^[^a-zA-Z]*$/.test(tValue.trim())) {
                    // isInvalidInput check — no letters at all
                    input.error = 'Please enter a valid ' + head.toLowerCase()
                }
            }
            break

        case 'hint':
        case 'comment':
        case 'subtitle':
        case 'description':
            if (tValue.length < 5) {
                input.error = 'Kindly input a valid ' + head
            } else if (tValue.length > 200) {
                input.error = head + ' cannot be more than 200 characters'
            } else {
                const characterCheck = hasInvalidSpecialChars(tValue)

                if (characterCheck.length > 0) {
                    input.error = `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}`;
                } else if (/^[^a-zA-Z]*$/.test(tValue.trim())) {
                    // isInvalidInput check — no letters at all
                    input.error = 'Please enter a valid ' + head.toLowerCase()
                }
            }
            break

        case 'amount':
            tValue = tValue.replace(',', '')
            const isValidAmount = /^\d+(\.\d{1,2})?$/.test(tValue);

            if (!isValidAmount) {
                input.error = isValidAmount ? '' : 'Invalid amount format';
            }
            break

        case 'first_name':
        case 'last_name':
            if (tValue.length < 3) {
                input.error = 'Please enter a valid ' + head
            } else if (tValue.length > 30) {
                input.error = head + ' cannot be more than 30 characters'
            } else {
                const characterCheck = hasInvalidSpecialChars(tValue)

                if (characterCheck.length > 0) {
                    input.error = characterCheck.length > 0 ? `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}` : ''
                } else if (/^[^a-zA-Z]*$/.test(tValue.trim())) {
                    // isInvalidInput check — no letters at all
                    input.error = 'Please enter a valid ' + head.toLowerCase()
                } else {
                    /* 
                     * Validate name details
                     * Set first character to upper case
                    */
                    tValue = tValue.charAt(0).toUpperCase() + tValue.slice(1)
                    input.value = tValue

                    let isValidName = nameValidator(tValue)

                    if (!isValidName) {
                        input.error = 'Please provide a valid ' + targetTitle.toLowerCase()
                    }
                }
            }
            break

        case 'email':
            const characterCheck = hasUnsupportedEmailCharacters(tValue)

            if (characterCheck.length > 0) {
                input.error = characterCheck.length > 0 ? `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}` : ''
            } else if (/^[^a-zA-Z]*$/.test(tValue.trim())) {
                // isInvalidInput check — no letters at all
                input.error = 'Please enter a valid ' + head.toLowerCase()
            } else {
                let isValidEmail = emailValidator(tValue)

                if (!isValidEmail) {
                    input.error = 'Please provide a valid email address'
                }
            }
            break

        case 'password':
        case 'confirm':
            const pwdMinLength = 8
            const pwdMaxLength = 30

            if (tValue.length < pwdMinLength) {
                input.error = 'Please enter a valid ' + head
            } else if (tValue.length > pwdMaxLength) {
                input.error = head + ' cannot be more than ' + pwdMaxLength + ' characters'
            } else {
                let isValidPwd = passwordValidator(tValue)

                if (!isValidPwd) {
                    input.error = 'Kindly set a strong password '
                }
            }
            break

        case 'unit_label':
            console.log('MINW', minChar);
            console.log('tValue.length', tValue.length);

            if (tValue.length < minChar) {
                input.error = 'Please enter a valid ' + head
            } else if (tValue.length > maxChar) {
                input.error = head + ' cannot be more than ' + maxChar + ' characters'
            } else {
                const characterCheck = hasInvalidSpecialChars(tValue)

                if (characterCheck.length > 0) {
                    input.error = `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}`;
                }
            }
            break

        default:
            if (tValue.length < minChar) {
                input.error = 'Please enter a valid ' + head
            } else if (tValue.length > maxChar) {
                input.error = head + ' cannot be more than ' + maxChar + ' characters'
            } else {
                const characterCheck = hasInvalidSpecialChars(tValue)

                if (characterCheck.length > 0) {
                    input.error = `Unsupported character${characterCheck.length > 1 ? 's' : ''} detected: ${characterCheck.join(', ')}`;
                } else if (/^[^a-zA-Z]*$/.test(tValue.trim())) {
                    // isInvalidInput check — no letters at all
                    input.error = 'Please enter a valid ' + head.toLowerCase()
                }
            }
            break
    }

    if (!isrequired) {
        input.error = tValue.length < 1 ? '' : input.error
    }

    input.value = tValue

    // Capitalize only the first letter of the entire string
    let cleanError = input.error.replace(/_/g, ' ');
    input.error = cleanError.charAt(0).toUpperCase() + cleanError.slice(1);

    return input
}

/**
 * Global Validation Logic for Sojourn Engine.
 * Adapted from G_onInputBlurHandler to support dynamic form validation formats.
 */
export function G_ValidationLogic(event: any, validationType: string, title: string = null, minChar = 2, maxChar = 30) {
    let inputName = event.target.name
    let isrequired = event.target.required
    let inputValue = event.target.value.trim()

    let validationOutcome: any = {
        error: '',
        value: inputValue
    }

    let displayTitle = title || inputName;
    displayTitle = displayTitle.toLowerCase();

    // Check for empty state values
    if (inputValue.length < 1) {
        if (isrequired) {
            validationOutcome.error = `${displayTitle} is required`;
            return finalizeResult(validationOutcome);
        }

        // If not required and input value is empty, it's valid. No further checks needed.
        return validationOutcome;
    }

    // Format-Specific Validation Logic (Executed if inputValue.length > 0)
    // Even if required is false, validate the format of the data entered.
    switch (validationType) {
        case 'first_last_names':
            if (inputValue.length < 2) {
                validationOutcome.error = 'Please enter a valid ' + displayTitle;
            } else if (inputValue.length > 30) {
                validationOutcome.error = displayTitle + ' cannot be more than 30 characters';
            } else {
                // Check inputValue for special char
                const charCheck = anthroponymCharCheck(inputValue);

                if (charCheck.length > 0) {
                    validationOutcome.error = `Invalid character${charCheck.length > 1 ? 's' : ''} found: [ ${charCheck.join(' ')} ].`;
                } else {
                    validationOutcome.value = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                }
            }
            break;

        case 'email':
            // Run the unified syntax and character check
            const emailCharCheck = mailboxSyntaxCheck(inputValue, displayTitle);

            // Handle errors based on priority
            if (emailCharCheck.unsupportedChars.length > 0) {
                validationOutcome.error = `Invalid character${emailCharCheck.unsupportedChars.length > 1 ? 's' : ''} found: [ ${emailCharCheck.unsupportedChars.join(' ')} ].`;
            } else if (emailCharCheck.error) {
                // Structural errors (like double dots or missing @)
                validationOutcome.error = emailCharCheck.error;
            } else {
                // Normalization: to lowercase
                validationOutcome.value = inputValue.toLowerCase().trim();
            }
            break;

        case 'amounts':
            const cleanAmount = inputValue.replace(/,/g, '');
            const isValidAmount = /^\d+(\.\d{1,2})?$/.test(cleanAmount);

            if (!isValidAmount) {
                validationOutcome.error = `Invalid ${displayTitle} format`;
            }
            break;

        case 'number_formats':
            // No comma separation allowed here
            if (!/^\d+$/.test(inputValue)) {
                validationOutcome.error = 'Please enter a valid number';
            }
            break;

        case 'url_links':
            const isValidUrl = /^(https?:\/\/)?([\w\d-]+\.)+[\w-]+(\/.*)?$/i.test(inputValue);

            if (!isValidUrl) {
                validationOutcome.error = 'Please provide a valid URL (e.g., https://google.com)';
            }
            break;

        case 'comments_descriptions':
            if (inputValue.length < 5) {
                validationOutcome.error = 'Kindly input a valid ' + displayTitle;
            } else if (inputValue.length > 250) {
                validationOutcome.error = displayTitle + ' cannot be more than 250 characters';
            } else if (/^[^a-zA-Z]*$/.test(inputValue)) {
                validationOutcome.error = 'Please enter a valid ' + displayTitle;
            }
            break;

        case 'password_confirm':
            const pwdMin = 8;
            if (inputValue.length < pwdMin) {
                validationOutcome.error = 'Please enter a valid ' + displayTitle;
            } else if (!passwordValidator(inputValue)) {
                validationOutcome.error = 'Kindly set a strong password';
            }
            break;

        case 'alphanumeric':
        default:
            if (inputValue.length < minChar) {
                validationOutcome.error = 'Please enter a valid ' + displayTitle;
            } else if (inputValue.length > maxChar) {
                validationOutcome.error = displayTitle + ' cannot be more than ' + maxChar + ' characters';
            } else {
                const charCheck = hasInvalidSpecialChars(inputValue);
                if (charCheck.length > 0) {
                    validationOutcome.error = `Unsupported character${charCheck.length > 1 ? 's' : ''} detected: ${charCheck.join(', ')}`;
                }
            }
            break;
    }

    if (!isrequired && inputValue.length < 1) {
        validationOutcome.error = '';
    }

    switch (validationType) {
        case 'alphanumeric':
        case 'first_last_names':
            validationOutcome.value = toTitleCase(validationOutcome.value)
            break;
    }

    return finalizeResult(validationOutcome);
}

/** Helper to clean up error strings and capitalize first letter */
function finalizeResult(input: { error: string, value: string }) {
    if (input.error) {
        let cleanError = input.error.replace(/_/g, ' ');
        input.error = cleanError.charAt(0).toUpperCase() + cleanError.slice(1);
    }

    return input;
}

/**
 * Scans a name string for characters that fall outside the permitted 
 * orthographic standards for human names (anthroponyms).
 * 
 * Supports:
 * - International letters (Unicode characters/accents)
 * - Defined special characters (.,'’- )
 * - Whitespace
 * 
 * @param input - The name string to evaluate.
 * 
 * @returns An array of unique unsupported characters found.
 */
function anthroponymCharCheck(input: string) {
    const allowedSpecialChars = `.,'’- `
    const unsupportedChars = new Set<string>();

    for (const char of input) {
        // \p{L} matches any letter in any alphabet
        // The 'u' flag at the end of the regex is required for Unicode properties
        const isLetter = /\p{L}/u.test(char);
        const isWhitespace = /\s/.test(char);
        const isAllowedSpecial = allowedSpecialChars.includes(char);

        if (!isLetter && !isWhitespace && !isAllowedSpecial) {
            unsupportedChars.add(char);
        }
    }

    return Array.from(unsupportedChars);
}

/**
 * Checks unsupported characters and structural violations on
 * electronic mailbox naming conventions (RFC 5322).
 * 
 * @param email - The email string to evaluate.
 * @param displayTitle - Represents the human-readable name of the input
 * 
 * @returns An array of unique unsupported characters found.
 */
function mailboxSyntaxCheck(email: string, displayTitle: string): any {
    let error: string | null = null;
    const unsupportedChars = new Set<string>();

    // Basic Structure Check (Exactly one '@')
    const parts = email.split('@');

    if (parts.length !== 2) {
        return {
            unsupportedChars: [],
            error: `${displayTitle} must contain exactly one '@' symbol.`
        };
    }

    const [localPart, domainPart] = parts;

    // Length Constraints (RFC Standards)
    if (localPart.length > 64 || domainPart.length > 255 || email.length > 254) {
        return {
            unsupportedChars: [],
            error: `The ${displayTitle} provided is too long.`
        };
    }

    //  Semantic Validation
    if (localPart.startsWith('.') || localPart.endsWith('.')) {
        error = `${displayTitle} cannot start or end with a period.`;
    } else if (localPart.includes('..')) {
        error = `${displayTitle} cannot contain consecutive periods.`;
    } else if (!domainPart.includes('.') || domainPart.endsWith('.')) {
        error = `Invalid domain structure in ${displayTitle}.`;
    }

    // Character check
    const allowedRegex = /[a-zA-Z0-9._\-+]/;

    for (const char of email) {
        if (char !== '@' && !allowedRegex.test(char)) {
            unsupportedChars.add(char);
        }
    }

    const unsupportedArray = Array.from(unsupportedChars);

    // If there are unsupported characters, prioritize that error
    if (unsupportedArray.length > 0) {
        error = `Invalid character${unsupportedArray.length > 1 ? 's' : ''} found in ${displayTitle}: [ ${unsupportedArray.join(' ')} ].`;
    }

    return {
        unsupportedChars: unsupportedArray,
        error
    };
}

function hasInvalidSpecialChars(input: string): string[] {
    const allowedSpecialChars = `.,'’()-:&/$()#@`; // Customize this list
    const unsupportedChars = new Set<string>();

    for (const char of input) {
        const isLetterOrDigit = /[\p{L}\p{N}]/u.test(char);
        const isWhitespace = /\s/.test(char);
        const isAllowedSpecial = allowedSpecialChars.includes(char);

        if (!isLetterOrDigit && !isWhitespace && !isAllowedSpecial) {
            unsupportedChars.add(char);
        }
    }

    return Array.from(unsupportedChars);
}

function hasUnsupportedEmailCharacters(email: string): string[] {
    const allowedCharsRegex = /^[a-zA-Z0-9@._\-+]+$/;
    const unsupportedChars = new Set<string>();

    for (const char of email) {
        if (!allowedCharsRegex.test(char)) {
            unsupportedChars.add(char);
        }
    }

    return Array.from(unsupportedChars);
}

const toTitleCase = (str: string) => {
    // Standard "Small Words" list
    const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v\.?|via)$/i;

    return str.split(' ').map((word, index, words) => {
        // Always capitalize the first and last words of the string
        if (index === 0 || index === words.length - 1) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }

        // Check if it's a small word
        if (smallWords.test(word)) {
            // THE INTENT CHECK:
            // If the user already capitalized the first letter, leave it as is.
            // Otherwise, force it to lowercase.
            const isFirstLetterUserCapitalized = word.charAt(0) === word.charAt(0).toUpperCase();
            
            return isFirstLetterUserCapitalized ? word : word.toLowerCase();
        }

        // For all other "Principal" words, capitalize them normally
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
}